module.exports = ({React,connect,Route,Navli,Modal,UserGroupsTab,UserTransactionsTab,UserDetailsTab,UserActions,ModalDates,UserDownloadsTab})=>

  {usersAreEditing,usersLoadSelected,usersSelectedUpdated,usersAreSelected,usersAdding,usersSaveSelected} = UserActions

  class UserModal extends React.Component

    constructor:(props)->
      super(props)
      @state = {trans_selected:[]}
    
    componentDidMount:->
      #load user data here
      if(@props.match.params.user_id != "new")
        @props.dispatch(usersAreEditing(true)) # need to set editing to true here and load user data
        @props.dispatch(usersLoadSelected("/duocms/api/users/"+@props.match.params.user_id))
      else
        @props.dispatch(usersAdding(true))
        @props.dispatch(usersAreSelected({}))

    componentDidUpdate:(prev_props)->
      if(@props.userImageUploading == false && @props.userSavedSuccess != prev_props.userSavedSuccess)
        # closes after saving, unless file is uploading
        @close()

    close:->
      @props.dispatch(usersAreEditing(false))
      @props.dispatch(usersAdding(false))
      @props.history.push("/users/")
  
    groupclicked:(group)->
      group_ids = @props.usersSelected[0].group_ids || []
      index = group_ids.indexOf(group.id)
      if index > -1
        group_ids.splice(index,1)
      else
        group_ids.push(group.id)
      @update(@props.usersSelected[0].id,"group_ids",group_ids)
    
    transactionclicked:(transction)->
      @setState({trans_selected:[transction]}) # just using this to highlight last selected
      path = ("/ecommerce/transactions/"+transction.id).replace(/\/+/g,"/") # prevent multiple slashes
      @props.history.push(path)
  
    save:->
      @props.dispatch(usersSaveSelected(@props.usersSelected[0],"User saved successfully"))
  
    update:(id,field,value)->
      @props.dispatch(usersSelectedUpdated(id,field,value))
    
    render:->
      user_id = @props.match.params.user_id
      has_ecom = (@props.settings && @props.settings.features && @props.settings.features.ecommerce) || false
      <Modal onclose={@close.bind(this)} onsave={@save.bind(this)} issaving={@props.usersAreSaving} >
        <ul className="nav nav-tabs">
          <Navli to={"/users/user/"+user_id+"/details"} className="user_details" location={@props.location} >NAFEMS User Details</Navli>
          <Navli to={"/users/user/"+user_id+"/groups"} className="user_groups"  location={@props.location}>Groups</Navli>
          { has_ecom && <Navli to={"/users/user/"+user_id+"/transactions/"} className="user_transactions" location={@props.location}>Transactions</Navli> }
          <Navli to={"/users/user/"+user_id+"/downloads"} className="user_downloads"  location={@props.location}>Downloads</Navli>
        </ul>
        <br />
        <Route path="/users/user/:user_id/details" key="userdetails" render={() => <UserDetailsTab orgs={@props.orgs} onUpdate={@update.bind(this)} />} />
        <Route path="/users/user/:user_id/groups" render={() => <UserGroupsTab user={@props.usersSelected[0]} groups={@props.groups} rowclicked={@groupclicked.bind(this)} />} />
        <Route path="/users/user/:user_id/transactions/" render={() => <UserTransactionsTab user={@props.usersSelected[0]} rowclicked={@transactionclicked.bind(this)} selected={@state.trans_selected} />} />
        <Route path="/users/user/:user_id/downloads/" render={() => <UserDownloadsTab user={@props.usersSelected[0]} />} />
        <ModalDates dates={@props.usersSelected?[0]} />
      </Modal>


  return connect(
    (state)=>
      usersSelected: state.usersSelected,
      orgs: state.orgs,
      groups:state.groups,
      usersAreSaving:state.usersAreSaving,
      userSavedSuccess:state.userSavedSuccess,
      settings:state.settings,
      userImageUploading:state.userImageUploading
    )(UserModal)